module.exports = __webpack_public_path__ + "img/IEC129254.44f7cf3f.png";